const checkForShouldSendSignature = (signatureConfig, ticketType, whatsapp) => {
  const isTicketWhatsapp = ticketType === 0;

  return signatureConfig === "enabled" && (!isTicketWhatsapp || whatsapp?.sendSignature);
};

export default checkForShouldSendSignature;
